import React from 'react';
import {BasicVacancyCard} from "./BasicVacancyCard";
import { Vacancy } from '../../types';

export function VacancyCardEmployer({ vacancy } : { vacancy: Vacancy }) {
    return (
        <BasicVacancyCard
            vacancy={vacancy}
        />
    )
}